global.jQuery = global.$ = require('jquery');

import 'bootstrap';
import './fslightbox';
import "slick-carousel";